import moment from 'moment';

$(() => {
  if ($('.is_mobile').is(':visible') || $('.is_tablet').is(':visible')) {
    return;
  }

  $('.js-custom-date-container').on('focus', '.js-custom-date', e => {
    const $customDate = $(e.currentTarget);
    const defaultTime = $customDate.data('default');
    $customDate.datetimepicker({
      format: 'HH:mm',
      stepping: 5,
      icons: {
        up: 'fas fa-angle-up',
        down: 'fas fa-angle-down',
      },
      defaultDate: moment(defaultTime, 'HH:mm'),
    });
  });
});
